
import type { PropType } from 'vue'
import type { Equalize, EqualizeFunctionField } from '../../modules/equalize'
import type { EqualizeDomainService } from '../../services/interfaces'
import { computed, defineComponent, getCurrentInstance } from 'vue'
import { mapGetters } from '../../composables/utils'

import { CONTAINER } from '../../config'

import { TYPES } from '../../config/inversify.types'

import { ColorEnum } from '../../enums'

import { capitalizeSentence } from '../../filters/capitalize-sentence.filter'

import { CONFIG_CONSTS } from '../../store/config/config.consts'

import { EpbBadge } from '../shared/epb-badge'
import { EpbSlide } from '../shared/epb-slide'
import EqualizeFeatureContainer from './equalize-feature-container.component.vue'

export default defineComponent({
  name: 'FunctionScoreFeatureContainer',
  components: {
    EpbBadge,
    EpbSlide,
    EqualizeFeatureContainer,
  },
  props: {
    item: {
      type: Object as PropType<Equalize>,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
    },
    disabled: Boolean,
    messages: {
      type: Object,
      required: true,
    },
  },
  setup(props: { item: Equalize; readonly: boolean; messages: object }) {
    const {
      proxy: { $store },
    } = getCurrentInstance()

    const domainService = CONTAINER.get<EqualizeDomainService>(TYPES.EqualizeDomainService)

    const defaultButtonDisabled = computed((): boolean => {
      return (
        !!Object.keys(props.item.defaultFeatures).length &&
        domainService.hasFunctionScoreDefaultValues(props.item.features, props.item.defaultFeatures)
      )
    })

    const { instanceConfig } = mapGetters($store, CONFIG_CONSTS.moduleName, {
      instanceConfig: CONFIG_CONSTS.getters.currentInstance,
    })

    const getPrettyName = (name: string): string => {
      const catalogFieldConfig = instanceConfig.value.catalog.fields.find(({ id }) => id === name)

      return capitalizeSentence(catalogFieldConfig?.prettyName ?? name)
    }

    const baseClass = 'epb-function-score-feature-container'

    const setDefaultValues = (): void => {
      domainService.setDefaultByFeature(
        'functionScore',
        props.item.features,
        props.item.defaultFeatures,
      )
    }

    const getBadgeText = (fieldConfig: EqualizeFunctionField): string => {
      return fieldConfig.boostFactor > 1
        ? `${fieldConfig.formulaType} x${fieldConfig.boostFactor}`
        : fieldConfig.formulaType
    }

    return {
      baseClass,
      domainService,
      defaultButtonDisabled,
      setDefaultValues,
      getPrettyName,
      ColorEnum,
      getBadgeText,
    }
  },
})
